import React from "react";
// javascript plugin used to create scrollbars on windows
import { Route, Switch } from "react-router-dom";

import { Container } from "reactstrap";

//Routes
import routes from "../routes/routes";

class External extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (

            <div className="content-auth" >
                <Container className="margin-auth">
                    <Switch>
                        {routes.map((prop, key) => {
                            return (
                                <Route
                                    path={prop.layout + prop.path}
                                    component={prop.component}
                                    key={key}
                                />
                            );
                        })}
                    </Switch>
                </Container>
            </div>
        );
    }
}

export default External;
